<div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
  
                <div class="col-md-10 report-main-content m-t-5">
                  <div class="coupon-card">
                    <div class="game-heading">
                      <span class="card-header-title">LIVE POKER </span>
                    </div>
                  </div>
                  <div>
                    <div class="m-b-30 div-figure" 
                    (click)="gotoexchangeGame('67564')">
                      <a>
                        <img src="assets/Casino/20-20-poker.jpg" class="img-fluid">
                      </a>
                    </div>
                    <div class="m-b-30 div-figure" 
                    (click)="gotoexchangeGame('67564')">
                      <a>
                        <img src="assets/Casino/1-day-poker.jpg" class="img-fluid">
                      </a>
                    </div>
                    <div class="m-b-30 div-figure" 
                    (click)="gotoexchangeGame('67564')">
                      <a>
                        <img src="assets/Casino/poker-6-player.jpg" class="img-fluid">
                      </a>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>